import { render } from "./cwc_notes.vue?vue&type=template&id=ce8f085a&scoped=true"
import script from "./cwc_notes.vue?vue&type=script&lang=js"
export * from "./cwc_notes.vue?vue&type=script&lang=js"

import "./cwc_notes.vue?vue&type=style&index=0&id=ce8f085a&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8f085a"]])

export default __exports__